export const bg = {
  common: {
    pageTitle: 'eHR.bg - Електронни трудови досиета',
    fullName: 'eHR (Електронни трудови досиета)',
    success: 'Успешно действие!',
    error: 'Грешка!',
    loading: 'Зарежда се',
    confirm: 'Потвърди',
    cancel: 'Отказ',
    save: 'Запази',
    saveAndContinue: 'Запази и продължи',
    saveAndSign: 'Запази и подпиши',
    back: 'Назад',
    ok: 'OK',
    edit: 'Редактирай',
    redact: 'Редактирай документ',
    and: 'и',
    from: 'от',
    for: 'по',
    yes: 'Да',
    no: 'Не',
    preview: 'Прегледай',
    delete: 'Изтрий',
    noPermission: 'Нямате достатъчно права',
    addPosition: '+ Добави позиция',
    home: 'Начало',
    error404: 'Страницата не може да бъде намерена или е възникнала грешка.',
    switchedMode: 'Превключихте на режим',
    with: 'с',
    import: 'Импорт',
    downloadTemplate: 'Свали темплейт',
    downloadErrorTemplate: 'Свали файл със сгрешените данни',
    importSuccess: 'Успешно импортирани - {{count}}.',
    importFailed: 'Неуспешно импортирани - {{count}}.',
    row: 'Ред',
    copyToClipboard: 'Копирай с един клик',
    requestAndSign: 'Заяви и подпиши',
    notExistingUser: 'Не съществува такъв потребител',
    currentlyUploadedFiles: 'Kачени файлове до момента:',
    has: 'Има',
    hasNot: 'Няма',
    cacheVersion: 'Успешно изчистване на кеш, в момента използвате версия:',
    create: 'Създай',
    viewEmpDocs: 'Преглед на документи за служител',
    createEmpDoc: 'Създай документ за служител',
  },
  biss: {
    generalError: 'Възникна грешка при извършването на подпис.',
    checkOption: 'моля проверете избраната опция за подписване!',
    noResponse: 'Грешка при свързване с BISS, моля проверете дали е стартиран!',
  },
  editor: {
    splitText: 'Раздели текст на блок',
  },
  auth: {
    login: {
      title: 'Вход в системата',
      email: 'Имейл',
      emailPlaceholder: 'Въведете имейл',
      pass: 'Парола',
      passPlaceholder: 'Въведете парола',
      forgottenPassword: 'Забравена парола?',
      code: 'Въведете кодa от приложението Ви за двуфакторна автентикация (шест цифри)',
      login: 'Вход',
    },
    forgottenPassword: {
      title: 'Забравена парола',
      email: 'Въведете имейл:',
      emailPlaceholder: 'Имейл',
      send: 'Изпрати',
    },
    resetPassword: {
      title: 'Възстановяване на парола',
      pass: 'Парола',
      passHint:
        'Tрябва да съдържа минимум 10 символа и поне по една малка буква, голяма буква, цифра и специален символ.',
      confirmPass: 'Повторете паролата',
      change: 'Промени',
      success: 'Обновихте Вашата парола.',
    },
    accountActivation: {
      title: 'Валидация в системата',
      pass: 'Парола',
      passHint:
        'Tрябва да съдържа минимум 10 символа и поне по една малка буква, голяма буква, цифра и специален символ.',
      confirmPass: 'Повторете паролата',
      validate: 'Валидирай',
      resendEmailActivation: 'Изпрати отново имейл за активация',
      resendActivationSuccessMsg: 'Съобщението за активиране на акаунта беше изпратено успешно.',
      gotoLogin: 'Към вход в системата',
    },
    twoFA: {
      googleAuth: 'Двуфакторна Аутентикация с Google Authenticator',
      microsoftAuth: 'Microsoft Двуфакторна Аутентикация',
    },
  },
  candidateApplication: {
    title: 'Форма за кандидатстване',
    firstName: 'Име',
    firstNameEn: 'Name',
    lastName: 'Фамилия',
    lastNameEn: 'Last name',
    email: 'Имейл',
    egn: 'ЕГН',
    address: 'Постоянен адрес',
    address_en: 'Permanent address',
    department: 'Отдел',
    selectDepartment: 'Изберете отдел',
    submit: 'Изпрати кандидатура',
    successMessage: 'Кандидатът беше добавен успешно (освен, ако вече не същестува потребител с такъв имейл)!',
    errorLoadingOptions: 'Грешка при зареждане на опциите за отдел.',
    otherInformation: 'Друга информация',
    otherInformationEn: 'Other Information',
    acceptTermsRequired: 'Необходимо е да приемете условията.',
    acceptTermsPrefix: 'Приемам условията на',
    termsTitle: 'Съгласието за обработка на лични данни',
  },
  form: {
    select: 'Избери',
    selectAll: 'Избери всички',
    selected: '{{count}} избран',
    selected_plural: '{{count}} избрани',
    removeAll: 'Премахни всички',
    create: 'Създай',
    noOptions: 'Няма опции',
    isRequired: 'Полето е задължително.',
    invalidEmail: 'Невалиден имейл адрес.',
    invalidFormat: 'Невалиден формат.',
    invalidWholeNumber: 'Числото трябва да е цяло число.',
    invalidValue: 'Посочете валидна стойност.',
    passMismatch: 'Двете пароли не съвпадат.',
    tooShort: 'Прекалено къса',
    weak: 'Слаба',
    okay: 'Добра',
    good: 'Много добра',
    strong: 'Силна',
    time: 'час',
    fillWithValidData: 'Попълнете коректно всички полета.',
  },
  table: {
    typeFilter: 'Тип',
    categoryFilter: 'Категория',
    groupFilter: 'Група',
    creatorFilter: 'Автор',
    userFilter: 'Служител',
    createdAtFilter: 'Дата на създаване',
    leavePeriod: 'Месец и година',
    statusFilter: 'Статус',
    activeStatus: 'Активен',
    inactiveStatus: 'Неактивен',
    releasedStatus: 'Освободен',
    search: 'Търси ...',
    firstPage: 'Първа страница',
    prevPage: 'Предишна страница',
    nextPage: 'Следваща страница',
    morePages: 'Повече страници',
    lastPage: 'Последна страница',
    allResultsShown: 'Показан {{total}} резултат',
    allResultsShown_plural: 'Показани {{total}} резултата',
    resultsShown: 'Показани {{startIndex}} - {{endIndex}} от {{total}} резултата',
    actions: 'Действия',
    noResults: 'Не са намерени резултати',
    sort: 'Сортирай',
    filterWarning:
      'Приложени са филтри. Възможно е да не виждате пълната информация. Моля, премахнете ги ръчно или презаредете страницата.',
  },
  menu: {
    createDocument: 'Създаване на документ',
    documents: 'Документи',
    myDocuments: 'Моите документи',
    structure: 'Структура',
    reports: 'Справки',
    workMode: 'Режим на работа: ',
    switchWorkMode: 'Работи като ',
    settings: 'Настройки',
    twoFA: 'Двуфакторна автентикация',
    support: 'Поддръжка',
    aboutUs: 'За нас',
    privacyPolicy: 'Поверителност',
    trainingMaterials: 'Обучителни материали',
    logout: 'Изход',
    leaves: 'Отпуски',
    myLeaves: 'Моите отпуски',
    colleaguesLeaves: 'Отпуски на екипа',
    hourlyAbsences: 'Почасови отсъствия',
    healthAndSafetyTraining: 'ЗБУТ',
    workTrips: 'Командировки',
  },
  addToHomescreen: {
    title: 'Добави в началния екран',
    install: 'Инсталирай на начален екран',
    description:
      'Този уебсайт има функционалност за добавяне на начален екран. Добавете го, за да го използвате като приложение.',
    description2:
      'Приложението е вече инсталирано или функцията не се поддържа от браузъра ви. Използвайте следните инструкции:',
    iosInstallInstructions1: '1) Натиснете "Share" най-долу на екрана ви',
    iosInstallInstructionsChrome1: '1) Натиснете бутона "Share" - най-горе, вдясно',
    iosInstallInstructions2: '2) Скролнете и натиснете "Add to Home screen"',
    iosInstallInstructions3: '3) Натиснете "Add" в горния десен ъгъл',
    androidInstallInscructions1: '1) Натиснете бутона "Menu" - най-горе, вдясно',
    androidInstallInscructions2: '2) Натиснете "Add to Home screen"',
  },
  newVersionAvailable: {
    title: 'Налична е нова версия',
    description: 'Налична е нова версия. Моля, презаредете страницата.',
    refresh: 'Презареди',
    later: 'По-късно',
  },
  documents: {
    title: 'Управление на документи',
    received: 'Получени',
    awaiting: 'За подпис/изпращане',
    sent: 'Изпратени',
    archived: 'Архив',
    file: 'Досие',
    trash: 'Кошче',
    internalDoc: 'Вътрешен документ',
    externalDoc: 'Външен документ',
    approvals: 'Одобрения',
    signatures: 'Подписи',
    docName: 'Име на документа',
    packageName: 'Име на пакет документи',
    packageName2: 'Package name',
    docName_lang2: 'Document name',
    eSign: 'Eлектронно подписване',
    eSignSubtitle: 'Зареждане на сертификатите за подпис',
    docActivity: 'Активност по документ към',
    table: {
      name: 'Име',
      moreDetails: 'Повече детайли',
      expectedActions: 'Очаквани действия:',
      noExpectedActions: 'Не се очакват действия',
      category: 'Категория',
      author: 'Автор',
      employee: 'Служител',
      group: 'Група',
      createdAt: 'Дата на създаване',
      send: 'Изпрати',
      archive: 'Архивирай',
      preview: 'Прегледай/Принтирай',
      history: 'Активност',
      docNumber: 'Номер',
      totalDocuments: 'Общ брой на документите',
      approval: 'Одобрение/заверка',
      approve: 'Одобри/завери',
      signing: 'Подписване',
      actionsEmployer: 'Действия от работодател:',
      approvedByEmployer: 'Одобрен от работодател',
      signedByEmployer: 'Подписан от работодател',
      actionsEmployee: 'Действия от служител:',
      approvedByEmployee: 'Одобрен от служител',
      signedByEmployee: 'Подписан от служител',
      approvedSignedByEmployee: 'Oт служител',
      signedAndApprovedByEmployee: 'Подписан и одобрен от служител',
      signedAndAprrovedByEmployer: 'Подписан и одобрен от работодател',
      sign: 'Подпиши',
      signOnly: 'Само подписване',
      signAndExitInterview: 'Подпиши и отвори анкета за изходящо интервю',
      verifyAndSign: 'Завери и Подпиши',
      approveAndSign: 'Одобри и Подпиши',
      reject: 'Отхвърли',
      actionComplete: 'Действието е завършено',
      actionWaiting: 'Очаква действие',
      actionRejected: 'Действието е отхвърлено',
      rejectedWithReason: 'Отхвърлен с причина: {{reason}}',
      lastUpdate: 'Последна промяна',
      actionNotRequired: 'Не се очаква действие',
      actionNotRequiredYet: 'Действието не се изисква все още',
      actionReview: 'Провери',
      modalReviewPrompt: 'Сигурни ли сте, че искате да маркирате този болничен като проверен?',
      previewDoc: 'Прегледай документа',
      docActivity: 'Активност по документа',
      confirmDocHeading: 'Сигурни ли сте?',
      confirmSendDocHeading: 'Изпращане',
      confirmArchiveDocHeading: 'Изпращане в Aрхив',
      confirmDeleteDocHeading: 'Изпращане в Кошче',
      confirmHardDeleteDocHeading: 'Изтриване на документ',
      confirmApproveDocMsg: 'Наистина ли искате да одобрите този документ?',
      confirmSendDocMsg_plural: 'Наистина ли искате да изпратите тези документи?',
      confirmApproveDocMsg_plural: 'Наистина ли искате да одобрите тези документи?',
      confirmVerifyDocMsg: 'Наистина ли искате да заверите този документ?',
      confirmApproveAndSignDocMsg: 'Наистина ли искате да одобрите и подпишете този документ?',
      confirmVerifyAndSignDocMsg: 'Наистина ли искате да заверите и подпишете този документ?',
      confirmSignDocMsg: 'Наистина ли искате да подпишете този документ?',
      confirmSignDocMsg_plural: 'Наистина ли искате да подпишете тези документи?',
      confirmRejectDocMsg: 'Наистина ли искате да отхвърлите този документ?',
      confirmSendDocMsg: 'Искате ли да изпратите този документ за одобрение?',
      confirmArchiveDocMsg: 'Искате ли да преместите документа в Архив?',
      confirmDeleteDocMsg: 'Искате ли да преместите документа в Кошче?',
      confirmHardDeleteDocMsg: 'Наистина ли искате да изтриете този документ?',
      confirmRejectReasonLabel: 'Причина за отхвърлянето',
      confirmArchiveReasonLabel: 'Причина за архивирането',
      signWithCodeLabel: 'Подписване',
      signWithCodeMsg: 'Въведете кодa от приложението Ви за двуфакторна автентикация',
      signWithCodeMsgAndExitForm:
        'Въведете кодa от приложението Ви за двуфакторна автентикация. Моля отворете и попълнете анкета за изходящо интервю',
      confirmApproveDocLabel: 'Да! Одобри',
      confirmVerifyDocLabel: 'Да! Завери',
      confirmApproveAndSignDocLabel: 'Да! Одобри и подпиши',
      confirmVerifyAndSignDocLabel: 'Да! Завери и подпиши',
      confirmSignDocLabel: 'Да! Подпиши',
      confirmRejectDocLabel: 'Да! Отхвърли',
      generateRejectDocument: 'Генерирай заповед за прекратяване',
      confirmRemoveDocLabel: 'Да! Премахни',
      confirmSendDocLabel: 'Да! Изпрати',
      confirmArchiveDocLabel: 'Да! Премести',
      confirmDeleteDocLabel: 'Да! Премести',
      confirmHardDeleteDocLabel: 'Да! Изтрий',
      approvedDocSuccessMsg: 'Документът беше одобрен!',
      approvedDocSuccessMsg_plural: 'Документите бяха одобрени!',
      verifiedDocSuccessMsg: 'Документът беше заверен!',
      approvedAndSignedDocSuccessMsg: 'Документът беше одобрен и подписан!',
      verifiedAndSignedDocSuccessMsg: 'Документът беше заверен и подписан!',
      signedDocSuccessMsg: 'Документът беше подписан!',
      signedDocSuccessMsg_plural: 'Документите бяха подписани!',
      rejectedDocSuccessMsg: 'Документът беше отхвърлен!',
      sentDocSuccessMsg: 'Документът беше изпратен!',
      archivedDocSuccessMsg: 'Документът е изпратен в Архив!',
      deletedDocSuccessMsg: 'Документът е изпратен в Кошче!',
      hardDeletedDocSuccessMsg: 'Документът е изтрит!',
      hardDeletedDocSuccessMsg_plural: 'Документите бяха изтрити!',
      notificationSent: 'Изпратено известие',
      multiActions: 'Множествени действия',
      multiApprove: 'Множествено одобрение/заверка',
      multiSend: 'Множествено изпращане',
      multiSign: 'Множествено подписване',
      noDocsSelected: 'Не сте избрали документи.',
      confirmDocsAware: 'Сигурни ли сте, че сте запознати с този документ?',
      confirmDocsAware_plural: 'Сигурни ли сте, че сте запознати с тези документи?',
      docActionsInProgress: 'Извършват се действия по документи.',
      docViewInformation: 'Информация за документа',
      docFromLeavesFeature: 'Документ обвързван с Отпуск, за повече информация вижте меню "Отпуски"',
      massDocShort: 'Масов док.',
      massDoc: 'Масов документ',
      viewAllEmployees: 'Виж всички служители',
      documentFor: 'Документ за:',
      sendAndOrArchive: 'Изпращане и/или архивиране на документ',
      filtersBtn: 'Филтри',
      hiddenLeaveDocuments:
        'Скрити са документи обвързани с отсъствия, създадени от меню Отпуски. Натисни, за да ги покажеш.',
      notHiddenLeaveDocuments:
        'Показват се документи обвързани с отсъствия, създадени от меню Отпуски. Натисни, за да ги скриеш.',
      hiddenWorkTripDocuments: 'Скрити са документи обвързани с командировки. Натисни, за да ги покажеш.',
      notHiddenWorkTripDocuments: 'Показват се документи обвързани с командировки. Натисни, за да ги скриеш.',
      showOnlyWaitingAction: 'Визуализирай всички документи, очакващи действие от работодател на страницата.',
      showAllDocuments: 'Натисни, за да видиш от тази страница документи очакващи действия само от теб.',
      archivedOn: 'Архивиран на',
      documentHolder: 'Пакет док. №',
      documentID: '№ док.',
      hiddenHealthAndSafetyDocuments: 'Скрити са документи обвързани със ЗБУТ.',
      notHiddenHealthAndSafetyDocuments: 'Показват се документи обвързани със ЗБУТ.',
      editFromFields: 'Редакция (от динамични полета, НЯМА да запази предишни ръчни промени в текста)',
      editFromText: 'Редакция (от текста, ще запази ръчни промени в текста)',
      download: 'Изтегли',
      massDownload: 'Масово изтегляне',
      delete: 'Изтрий',
    },
    activity: {
      action: 'Действие',
      number: 'Номер',
      description: 'Описание',
      date: 'Дата',
      receipt: 'Разписка',
      backToDocsList: 'Назад към списъка с документи',
      backToReports: 'Назад към справки',
      docFilter: 'Документ',
      userFilter: 'Служител',
    },
    bulkDownload: {
      preparing: 'Подготовка на изтегляне',
      pleaseWait: 'Моля изчакайте, докато подготвяме документите ви...',
      immediateDownloadMessage:
        'Започна свалянето на вашите документи, моля провере в папка Сваляния/Downloads на браузъра ви.\n\nАко файловете липсват, проверете, дали браузърът ви не блокира свалянето.\n\nАко искате да свалите архив - свалете 11 или повече файла.',
      archiveGenerating: 'Архивът се генерира',
      archiveMessage:
        'Когато е готов, ще получите уведомление по имейл, и ще бъде достъпен в меню Архиви (горе вдясно). Линковете за сваляне на генериран архив са валидни 10 минути.',
      error:
        'Възникна грешка при подготовката на изтеглянето. Моля опитайте отново, с други документи, или по-късно.\n\nПри продължаващ проблем - свържете се с нас на support@ehr.bg',
      tooltip: 'При избиране на до 10 документа, ще се свалят отделни файлове. При повече, ще бъде генериран zip архив',
    },
  },
  structure: {
    title: 'Управление на структура',
    overtime: {
      employee: 'Служител',
      group: 'Група',
      day_work: 'Работи на',
      day_off: 'Почива на',
      actions: 'Действия',
      selectEmployee: 'Избери служител',
      workAtDate: 'Ще работи на',
      restAtDate: 'Ще почива на',
      workingHours: 'Работни часове',
      confirmDocHeading: 'Сигурни ли сте?',
      confirmRejectDocMsg: 'Наистина ли искате да отхвърлите работния ден?',
      confirmRejectDocLabel: 'Да! Отхвърли',
      cancel: 'Отказ',
      submit: 'Добави',
      overtimeHeading: 'Добавяне на работен ден',
      rejectedOvertimeSuccessMsg: 'Успешно отхвърлихте работния ден',
      overtimeView: 'Въвеждане работни дни',
      addSuccessMsg: 'Успешно добавихте работния ден',
      fullDay: 'Цял ден',
      hourly: 'Почасово',
      type: 'Вид почивка',
      hoursOfRestPerDay: 'Часове почивка на ден',
      startRestingAt: 'Ще започне да почива от',
      restInTwoDays: 'Почивка в 2 дни',
      hoursSmall: 'ч.',
    },
    groups: {
      title: 'Групи',
      addBtnLabel: 'Добавяне на група',
      name: 'Име',
      address: 'Адрес',
      description: 'Описание',
      visibleToCandidates: 'Видима за кандидати',
      createTitle: 'Добавяне на група',
      createSuccessMsg: 'Създадохте група',
      editTitle: 'Редактиране на група',
      employees: 'Служители в тази група',
      moderators: 'Модератори с достъп до тази група',
      editSuccessMsg: 'Редактирахте група',
      deleteSuccessMsg: 'Групата беше изтрита.',
      deleteConfirmTitle: 'Изтриване на група',
      deleteConfirmMsg: 'Сигурни ли сте, че желаете да изтриете група',
    },
    roles: {
      title: 'Роли',
      addBtnLabel: 'Добавяне на роля',
      name: 'Име',
      createTitle: 'Добавяне на роля',
      createSuccessMsg: 'Създадохте роля',
      editTitle: 'Редактиране на роля',
      editSuccessMsg: 'Редактирахте роля',
      deleteSuccessMsg: 'Ролята беше изтрита.',
      deleteConfirmTitle: 'Изтриване на роля',
      deleteConfirmMsg: 'Сигурни ли сте, че желаете да изтриете роля',
      employees: 'Служители с тази роля',
    },
    employees: {
      title: 'Потребители',
      addBtnLabel: 'Добавяне на потребител',
      name: 'Име',
      name_en: 'Name',
      middleName: 'Презиме',
      middleName_en: 'Middle name',
      lastName: 'Фамилия',
      lastName_en: 'Last name',
      type: 'Тип на потребителя',
      createdAt: 'Дата на регистрация',
      status: 'Статус',
      twoFaStatus: 'Двуфакторно автентикиране',
      active: 'Активно',
      inactive: 'Неактивно',
      groups: 'Членство в групи',
      mainGroup: 'Основен отдел',
      groupRights: 'Достъп по групи',
      roles: 'Добавяне на роли',
      allRoles: 'Роли',
      approveDocs: 'Одобряване на документи',
      signDocs: 'Подписване на документи',
      manageEmployees: 'Управление на служители',
      manageModerators: 'Управление на модератори',
      manageGroups: 'Управление на групи',
      manageRoles: 'Управление на роли',
      manageDocPermissions: 'Управление на права по документи',
      manageHealthAndSafetyTraining: 'Управление на обучения по здравеопазване и безопасност',
      manageWorkTrips: 'Управление на командировки',
      manageLeaves: 'Управление на отпуски',
      downloadUserDataReport: 'Достъп справка служителски данни',
      viewSensitiveFieldsOnUserDataReport: 'Достъп чувствителни данни в справка служителски данни',
      approveDocsDesc: 'Да одобрява документи (само ако има и право за това на ниво роля и категория документи).',
      signDocsDesc: 'Да подписва документи с КЕП (само ако има и право за това на ниво роля и категория документи).',
      manageEmployeesDesc: 'Може да създава, редактира и управлява профили на служители.',
      manageModeratorsDesc: 'Може да създава, редактира и управлява профили на модератори.,',
      manageGroupsDesc: 'Може да създава и управлява групи.',
      manageRolesDesc: 'Може да създава и управлява роли.',
      manageDocPermissionsDesc: 'Може да управлява нива на одобрение и подписване по категории документи.',
      manageLeavesDesc: 'Достъп до отпуски и болнични на служители',
      manageHealthAndSafetyTrainingDesc: 'Достъп до модул за здравословни и безопасни условия на труд (ЗБУТ).',
      manageWorkTripsDesc: 'Достъп до модул за командировки на служители.',
      downloadUserDataReportDesc: 'Може да генерира и сваля справка с данни на служители.',
      viewSensitiveFieldsOnUserDataReportDesc:
        'Достъп до чувствителни данни в справка данни на служители (ЕГН, Лична карта номер/издадена на и от, Мобилен Телефон, Основна заплата, Постоянен адрес, Настоящ адрес.',
      egn: 'ЕГН',
      dateOfBirth: 'Дата на раждане',
      IDCardNumber: 'Л.к. №',
      IDCardNumberHint: '9 цифри. За ЛК издадени след Юни 2024 г. - 2 букви на английски, последвани от 7 цифри.',
      IDCardIssuedAt: 'Л.к. издадена на',
      IDCardExpiresAt: 'Л.к. изтича на',
      IDCardIssuedInCity: 'Л.к. от МВР - град',
      IDCardIssuedInCity_en: 'ID card issued at',
      education: 'Образование',
      educationalLevel: 'Образователна степен',
      legalRelationship: 'Вид правоотношение',
      directorate: 'Наименование на дирекцията',
      department: 'Наименование на отдел',
      administrativeUnit: 'Вид на административното звено',
      positionLevel: 'Вид на длъжностно ниво',
      positionLevelLeading: 'Ръководно длъжностно ниво',
      positionLevelExpert: 'Експертно длъжностно ниво',
      positionLevelSpecialist: 'Длъжностно ниво специалист',
      positionLevelKDA: 'Наименование на длъжността според КДА',
      rang: 'Ранг',
      monthlySalaryLevel: 'Ниво на основната месечна заплата',
      monthlySalaryLevelDegree: 'Степен на основната месечна заплата',
      address: 'Постоянен адрес',
      address_en: 'Permanent address',
      currentAddress: 'Настоящ адрес',
      currentAddress_en: 'Current address',
      mobilePhone: 'Мобилен телефон',
      mobilePhoneHint: 'Изписва се мобилният телефон с код на държавата и код на оператор. Например: +359...',
      position: 'Длъжност',
      position_en: 'Occupation',
      nkpdCode: 'Код по НКПД', // National Standard Classification of Occupations
      grossSalary: 'Основна заплата (в евро)',
      grossSalaryHint:
        'Посочва се основната заплата на работника или служителя в евро. Изписва се само с цифри. Например: 850',
      grossSalaryMunicipality: 'Индивидуална основна месечна заплата',
      bonus: 'Допълнително възнаграждение за натрупан стаж и професионален опит',
      bonusHint:
        'Посочва се само с цифри, като минималният размер на възнаграждението е ' +
        '0.6 на сто от основната заплата. Например: 0.6 или по-голямо число.',
      paymentDeadline: 'Срок за изплащане на трудовото възнаграждение',
      paymentDeadlineHint: 'Посочва се число от месеца, до което да бъде изплатено възнаграждението. Например: 20-о.',
      workingHours: 'Работно време',
      workingHoursHint: 'Избира се продължителността на работния ден',
      placeOfWork: 'Място на работа',
      placeOfWork_en: 'Place of work',
      placeOfWorkHint: 'Посочва се населеното място, в което следва да се полага труда. Например: гр. София',
      placeOfWorkHint_en: 'Point out location in which the work shall be provided. For example: Sofia ',
      workingPlace: 'Работно място',
      workingPlace_en: 'Working place',
      annualLeaves: 'Годишен отпуск',
      leaveDaysPerYear: 'Платен отпуск по години',
      mainLeaves: 'Основен отпуск',
      mainLeavesHint: 'Посочва се броят дни, определени за основен годишен отпуск. Изписва се само с цифри.',
      additionalLeaves: 'Допълнителен отпуск',
      additionalLeavesHint: 'Посочва се броят дни, определени за допълнителен годишен отпуск. Изписва се само с цифри.',
      additionalLeavesHintForEditedField:
        'Моля уверете, се че за извършените промени по платен отпуск са създадени нужните документи',
      additionalEmailHint:
        'Внимание, ще извършите промяна на имейл, който е зададен за уведомления свързани с трудовото досие. Попълнете допълнително споразумение за е-Обмяна, ако вече не сте го направили',
      noticeDeadline: 'Срок на предизвестието',
      mainGroupWarning: 'Премахната е основната група на служителя!',
      probationPeriod: 'Изпитателен срок',
      duration: 'Времетраене',
      inFavorOf: 'В полза на',
      contractNumber: 'Номер на договор',
      other: 'Друго',
      other_en: 'Other',
      otherInfo: 'Друга информация',
      representative: 'Представляващ',
      representativeHint: 'Отбелязване на управител като представляващ работодателя',
      representativeMunicipalityHint: 'Отбелязване на кмет като представляващ',
      twoFaReset: 'Рестартиране на двуфакторно автентикиране',
      createTitle: 'Добавяне на потребител',
      createSuccessMsg: 'Създадохте потребител',
      editTitle: 'Редактиране на потребител',
      editSuccessMsg: 'Редактирахте потребител',
      importTitle: 'Импорт на потребители',
      firstWorkingDay: 'Дата на постъпване на работа',
      lastWorkingDay: 'Последен ден на работа',
      accessToSensitiveData: 'Достъп до чувствителни данни',
      manageRights: 'Управление на правата по категории',
      manageGroupRoleLimits: 'Управление на ограниченията по групи и роли',
      rolesTableInfo:
        'Можете да промените достъпа на потребителя до категории, като натиснете бутоните да/не. Няма възможност да се премахне достъп до всички групи!',
      backToEdit: '< Обратно към пълно редактиране на потребител',
      limitedAccess: 'Доп. ограничение по категории',
      leaveDaysServedTime: 'Дни натрупан и използваем отпуск за прослужено време',
      leaveDaysIrregularWorkingHours: 'Дни използваем отпуск за работа с ненормирано работно време',
      leaveDaysSpecificWorkingConditions: 'Дни използваем отпуск за специфични условия на труд',
      leaveDaysAdditionalLeave: 'Дни натрупан и използваем допълнителен отпуск',
      leavesWfh: 'Брой дни работа от вкъщи',
      perWeek: 'на седмица',
      perMonth: 'на месец',
      alwaysEligibleAsSubstitute: 'Винаги наличен като заместващ',
      releasedStatusValidation: {
        emptyDateTitle: 'Потвърждение на статус "Освободен"',
        emptyDateMessage:
          'Променяте статуса на този потребител на "Освободен", но не сте посочили изрично "Последен работен ден". Това може да доведе до некоректна информация в бъдещи справки. Желаете ли:',
        emptyDateUseToday: 'еHR автоматично да използва днешната дата',
        emptyDateManualEdit: 'Да въведа датата ръчно',
        emptyDateLeaveEmpty: 'Да оставя полето празно',
        pastDateTitle: 'Потвърждение на статус "Освободен"',
        pastDateMessage:
          'Променяте статуса на този потребител на "Освободен", но посоченият "Последен работен ден" е в миналото. Това може да доведе до некоректна информация в бъдещи справки.',
        pastDateConfirm: 'Информацията е вярна, Запази',
        pastDateEdit: 'Искам да редактирам, Отказ',
        futureDateTitle: 'Потвърждение на статус "Освободен"',
        futureDateMessage:
          'Променяте статуса на този потребител на "Освободен", но посоченият "Последен работен ден" е в бъдещето. След промяна на статуса на "Освободен" сега, потребителят няма да има достъп до еHR, но може би очаквате действия от него.',
        futureDateConfirm: 'Информацията е вярна, Запази',
        futureDateEdit: 'Искам да редактирам, Отказ',
      },
      calculateLeaveBtn: 'Изчисли отпуск',
      calculateLeaveBtnHint:
        'За изчислението е необходимо да са попълнени Работно време (стойност и на ден/седмица/месец), Основен отпуск и Дата на постъпване на работа. eHR не носи отговорност за некоректно въведени данни. ',
      leaveDaysTooltip:
        'Полето може да бъде попълнено ръчно или автоматично чрез бутона за изчисление. Полагаемият отпуск за годината се определя пропорционално спрямо стойността на Основен отпуск, началната дата и работното време на служителя.',
    },
    scenarios: {
      title: 'Права',
      category: 'Категория',
      createDocs: 'Създаване на документи',
      approveDocs: 'Одобряване на документи',
      signDocs: 'Подписване на документи',
      sendAndArchiveDocs: 'Изпращане и архивиране на документи',
      notify: 'Уведомяване за движение',
      manageLeaves: 'Управлениe на отпуски',
      confirmMassChange: 'Искате ли да приложите тези промени към всички категории в тази колона?',
      confirmContent:
        'Потвърдете премахването на тези права. ' +
        'С това действие ще бъдат премахнати и ' +
        'съответните конфигурирани нива за одобрение и подписване.',
    },
    multiActions: {
      title: 'Одобрение и подписване',
      number: 'Номер',
      docName: 'Име на документ',
      type: 'Вид',
      approvals: 'Одобрения',
      approvalNotRequired: 'Не е нужно одобрение',
      signatures: 'Подписи',
      signNotRequired: 'Не е нужeн подпис',
      defaultBehaviour: 'Избери поведение по подразбиране за документите в тази категория',
    },
  },
  reports: {
    title: 'Създаване на справка',
    documents: 'Документи',
    documentsByAction: 'Документи по действия',
    leaves: 'Отпуски',
    leavesDetailed: 'Обобщената справка по отсъствия',
    leavesFormSixtySeven: 'Форма 76',
    leavesList: 'Детайлна справка отсъствия по дни',
    leavesAvailability: 'Налични дни платен отпуск по служител',
    employeeData: 'Данни на служители',
    municipality: 'Община',
    categories: 'Категории',
    groups: 'Групи',
    docName: 'Име на документа',
    employees: 'Служители',
    author: 'Автор',
    fromDate: 'От дата',
    month: 'месец',
    toDate: 'До дата',
    leaveType: 'Вид отпуска',
    leaveStatus: 'Статус',
    submitBtn: 'Генерирай справка',
    downloadReport: 'Свали генерираната справка',
    downloadLeavesReport: 'Свали справка',
    downloadEmployeeDataReport: 'Свали справка',
    downloadWorkTripsDataReport: 'Свали подробна справка',
    employeeStatus: 'Статус',
    expandAll: 'Покажи всички',
    collapseAll: 'Скрий всички',
    actions: 'Действия',
    actionDate: 'Дата на действието',
    downloadXML: 'Свали справка за импорт в Микроинвест ТРЗ (XML)',
    leaveStatistics: 'Информация включена в тази XML справка:',
    leavesCount: 'Общ брой отпуски',
    manuallyAdded: 'Ръчно добавени отпуски',
    hasOverlappingLeavesForSameEmployee: 'Препокриване в отпуските на един и същ служител',
    paidleaveDaysCurr: 'Дни платен отпуск (от полагаеми за текуща година)',
    paidleaveDaysPrev: 'Дни платен отпуск (от полагаеми за предходна година)',
    paidleaveDays157: 'Дни платен отпуск по чл. 157',
    unpaidLeaveDays: 'Дни неплатен отпуск',
    overlappingLeaves: 'Внимание - има служители с препокриващи се отпуски в един ден. Техните имена са:',
    hourlyAbsences: 'Почасови отсъствия',
    workTrips: 'Командировки',
    viewDocumentsByAction: 'Визуализирай справка',
    downloadDocumentsByAction: 'Свали справка',
    viewLeavesAvailabilityReport: 'Визуализирай справка',
    firstName: 'Име',
    middleName: 'Презиме',
    lastName: 'Фамилия',
    position: 'Длъжност',
    group: 'Група',
    status: 'Статус',
    leavesAvailabilityServedTime: 'Дни платен отпуск за прослужено време',
    leavesAvailabilityAdditional: 'Допълнителен платен отпуск',
    leavesAvailabilityIrregularWorkingHours: 'Платен отпуск за ненормиран работен ден',
    leavesAvailabilitySpecificWorkingConditions: 'Платен отпуск при специфични условия на труд',
    healthAndSafetyTraining: 'ЗБУТ',
    downloadAladdin: 'Справка Аладин',
    downloadBusinessNavigator: 'Справка Бизнес Навигатор',
    businessNavigatorDownloadInfo:
      'Моля, преди импортиране на данните, потвърдете, че всички действия по отсъствия за месеца са завършени',
    downloadStil: 'Справка СТИЛ',
    noLeavesAndSick: 'Справката НЕ съдържа Болнични и Работа от вкъщи',
    noEmployeeDocumentsOrAccess: 'За избрания служител все още няма създадени документи или нямате достъп до тях.',
  },
  fileUploader: {
    dropFiles: 'Пуснете файловете тук.',
    placeholder: 'Качете файловете тук или кликнете, за да изберете файл.',
    hint: 'Позволени файлови разширения: {{accept}}',
    duplicatedFile: 'Този файл вече е качен - {{name}}.',
    tooLargeFile: 'Файлът, който се опитвате да качите, е прекалено голям. Максималният допустим размер е 20 MB.',
    approveUploadedFile: 'С подписване на този болничен, заявявате, че приложените файлове са автентични',
    noNeedToApproveUploadedFile:
      'С извършването на действието, заявявате, че ще предоставите документа за болничен на работодателя извън еHR',
    approvePaidLeaveUploadedFile:
      'Заявяването на такъв тип платен отпуск изисква предоставянето на съответния документ. ' +
      'Моля прикачете един или повече.',
  },
  docWizard: {
    title: 'Създаване на документ',
    editTitle: 'Редактиране на документ',
    operatorMessage: 'Оператори не могат да създават документи',
    prevStep: 'Предишна стъпка',
    nextStep: 'Следваща стъпка',
    saveDoc: 'Запази документа',
    editBtn: 'Промени името на пакета с документи',
    step1: {
      title: 'Форма',
      description: 'Избор на документ',
      massDoc: 'Масов документ',
      docType: 'Тип на документите',
      docCategory: 'Категория',
      docTemplate: 'Документ',
      docGroup: 'Група',
      docEmployee: 'Служител',
      externalTitle: 'Форма',
      externalDescription: 'Избор на служител и категория за документите',
      systemDocTemplates: 'Форми на документи от системата',
      externalDocs: 'Външни документи',
      selected: 'Избрани',
      leaves: 'Отпуски',
      showLeavesInfoTextForEmployer: `При извършване на корекции по платен отпуск
      при нужда, моля отразете промените и в профила на потребителя ръчно.`,
      showLeavesInfoTextForEmployee: 'Моля, заявете отпуск чрез <a>меню Отпуски</a>.',
      select: 'Избери',
      deselect: 'Премахни',
      selectOnlyActive: 'Избери само активни',
    },
    step2: {
      title: 'Конфигурация',
      description: 'Настройки на документ',
    },
    step3: {
      title: 'Информация',
      description: 'Информацията, която трябва да въведете',
      fieldsTitle: 'Попълнете полетата, нужни за създаването на документите',
      fieldsEditTitle: 'Попълнете полетата, нужни за редактирането на документите',
      missingFieldsText: 'Този документ няма налични полета за редакция, моля преминете към следващата стъпка.',
      attachDocuments: 'Прикачете допълнителни документи',
      externalTitle: 'Файлове',
      externalDescription: 'Качване/Добавяне на сканираните файлове',
      userError: 'Моля въведете правилно данните на служител: {{user}}',
      multiUserWarning:
        'Над тази линия виждате полетата, които ще бъдат с еднакво съдържание във всеки документ.</br>Под нея виждате всеки избран служител и може да попълните специфичните му данни.',
    },
    step4: {
      title: 'Преглед',
      close: 'Затвори',
      description: 'Предварителен преглед и опция за промяна',
      descriptionShort: 'Преглед и промяна',
      editDocBeforeSave: 'Редактиране преди записване',
      docWatermarkText:
        'Документ с Номер: {{number}} е генериран от системата eHR.bg на {{nowDate}} от потребител {{name}}',
      docWatermarkText_lang2:
        'Document with number: {{number}} has been generated in eHR.bg system on {{nowDate}} by {{name}}',
      massDocWatermarkText: 'Масов документ е генериран от системата eHR.bg на {{nowDate}} от потребител {{name}}',
      massDocWatermarkText_lang2: 'Mass document has been generated in eHR.bg system on {{nowDate}} by {{name}}',
      saveDocChanges: 'Запази промените',
      discardDocChanges: 'Отмени промените',
      multilingualHintText: 'Английската версия на документа може да бъде видяна под основната.',
    },
    step5: {
      title: 'Финализиране',
      description: 'Запис и одобрение',
      storagePeriod: 'Срок за съхранение',
      storageDate: 'Дата на съхранение',
      docScenario: 'Действие с документа',
      approveAndSignLevels: 'Нива за одобрение и подписване:',
      notifyForStatusUpdate: 'Уведомяване за движение на документа:',
      confirmSubmissionHeading: 'Сигурни ли сте?',
      confirmSubmissionMessage: 'Ще създадете масово документи за {{count}} служителя!',
      confirmSubmissionLabel: 'Да, създай!',
      confirmMassChangeHeading: 'Сигурни ли сте?',
      confirmMassChangeMessage:
        'Искате ли да приложите този срок за съхранение и действие за всички външни документи от пакета?',
      confirmMassChangeLabel: 'Да, промени!',
      successMsgHeading: 'Успешно действие!',
      saveWithOption: 'Запази с опция за масово прилагане',
      editWithOption: 'Редактирай с опция за масово прилагане',
      successMsgMulti:
        'Създадохте документи за {{count}} служителя.</br>Възможно е пълното създаване да отнеме малко време.</br>Ако не виждате документ, моля опитайте отново след малко.',
      successMsgSingle: 'Създадохте документа',
      loadingHeading: 'Моля изчакайте',
      loadingMsg: 'Създаване на документи...',
      exitInterview: {
        prompt: 'Желаете ли попълване на анкета за изходящо интервю?',
        promptAccept: 'Да, създай документа и отвори анкета за изходящо интервю',
        promptReject: 'Не, само създай документа',
      },
    },
  },
  profile: {
    title: 'Настройки на профил',
    personalInfo: 'Лични данни',
    name: 'Име',
    email: 'Имейл',
    changePassword: 'Смяна на парола',
    currentPass: 'Текуща парола',
    pass: 'Парола',
    passHint:
      'Tрябва да съдържа минимум 10 символа и поне по една малка буква, голяма буква, цифра и специален символ.',
    confirmPass: 'Повторете паролата',
    code: 'Код за потвърждение',
    codeHint: 'Въведете кодa от приложението Ви за двуфакторна автентикация.',
    feVersion: 'Текуща Front-End версия:',
  },
  twoFA: {
    title: 'Двуфакторно автентикиране',
    activateTitle: 'Активиране на двуфакторно автентикиране',
    instructions: 'Инструкции',
    QRcode: 'QR код за сканиране и верификация',
    manualVerification: 'Ръчна верификация',
    activationSuccessMsg: 'Активирахте Вашата двуфакторна автентикация.',
    activate: 'Активирай',
    code: 'Код',
    codeHint: 'Код за верификация',
    restartBtn: 'Рестартиране на двуфакторно автентикиране',
    confirmTitle: 'Сигурни ли сте?',
    confirmMsg: 'Желаете ли да премахнете двуфакторната автентикация?',
    removeBtn: 'Премахни',
    warning: 'Възможно е кодът да не е валиден заради некоректни дата и/или час на телефона ви.',
    instuctions: {
      title: 'Насоки как да проверите тук.',
      heading: 'Упътване за настройка на време в Google Authenticator',
      step1: 'A) Отворете менюто горе вляво',
      step2: 'Б) Изберете "Настройки".',
      step3: 'В) Изберете "Корекция на часа за кодове"',
      step4: 'Г) Изберете "Синхронизиране сега"',
      step5: 'Д) Би следвало да видите съобщение "Часът вече е правилен"',
      step6: 'Е) Натиснете бутона ОК и опитайте да въведете кода отново',
    },
  },
  leaves: {
    leaves: 'Отсъствия',
    noLeaves: 'Няма отсъствия',
    otherLeaves: 'Други',
    attendantTooltip: 'Използвайте опцията, за да видите "присъствени" записи',
    inProgress: 'В процес',
    colleagueTitle: 'Отпуски на екипа',
    step: 'Стъпка',
    title: 'Отпуски / Болнични',
    details: 'Детайли',
    titleManuallyInsert: 'Ръчно вевеждане на отсъствие',
    attachmentsList: 'Списък с файлове',
    requestDocPreview: 'Преглед на молба',
    orderDocPreview: 'Преглед на заповед',
    rejectionRequestDocPreview: 'Преглед на молба за прекратяване',
    createTitle: 'Заявяване на отпуска / болничен',
    createTitleWFH: 'Заявяване на отпуска / болничен / работа от вкъщи',
    createTitleWFO: 'Заявяване на отпуска / болничен / работа от вкъщи / работа от офис',
    previousTitle: 'Информация за отминали отсъствия',
    note: 'Брой неизползвани дни платен отпуск: ',
    noteTimeServed: 'Брой налични дни платен отпуск за прослужено време: ',
    noteIrregularWorkingHours: 'Брой налични дни платен отпуск за работа с ненормирано работно време: ',
    noteSpecificWorkingConditions: 'Брой налични дни платен отпуск за специфични условия на труд: ',
    noteAdditionalLeave: 'Брой налични дни допълнителен отпуск: ',
    noteWfhWeekly: 'Брой налични дни работа от вкъщи за текущата седмица: ',
    noteWfhMonthly: 'Брой налични дни работа от вкъщи за текущия месец: ',
    tooltipFutureYear: 'Тези дни отпуск не могат да бъдат използвани за текущата година',
    addLeaveBtn: 'Нов отпуск / болничен',
    type: 'Тип отсъствие',
    typeShort: 'Тип',
    subType: 'Под тип отсъствие',
    subTypeShort: 'Под тип',
    substituteEmployee: 'Ще бъда заместван от',
    substituteEmployeeManual: 'Ще бъде заместван от',
    filterReview: 'Филтрирай отсъствия по проверени',
    filterReviewDeselected: 'Филтрирай отсъствия по проверени',
    dateFromTo: 'Начална - Крайна дата',
    dateFrom: 'Начална дата',
    fromInterrupted: 'Начало',
    toInterrupted: 'Край',
    dateRange: 'Период',
    deleteConfirmation: 'Сигурни ли сте, че желаете да изтриете избрания отпуск?',
    deleteHeading: 'Изтриване на ръчно добавен отпуск',
    insertType: 'Начин на създаване',
    insertTypeManually: 'Ръчно',
    dateTo: 'Крайна дата',
    requestDocumentId: 'Номер на документ - молба',
    requestDocumentComment: 'Номер на достъпен и съществуващ документ от системата',
    orderDocumentId: 'Номер на документ - заповед',
    orderDocumentComment: 'Номер на достъпен и съществуващ документ от системата. Може да бъде като на молбата.',
    commentInfoManual: 'Коментарът ще бъде видим за служителя.',
    year: 'Година',
    numberOfDays: 'Брой дни',
    userCount: 'Брой активни служители',
    approveAndSignOrder: 'Потвърди и подпиши заповед',
    signRejectDocument: 'Подпиши заповед за прекратяване',
    signRejectRequestDocument: 'Подпиши молба за прекратяване',
    group: 'Група',
    status: 'Статус',
    month: 'Месец',
    paid: 'Платен отпуск',
    additional: 'Допълнителен отпуск',
    work_from_home: 'Работа от разстояние',
    work_from_office: 'Работа от офис',
    otherPaid: 'Други платени отпуски',
    unpaid: 'Неплатен отпуск',
    sick: 'Болничен',
    paid_ordinary: 'Стандартен',
    paid_blood_donation: 'За кръводаряване (чл. 157, ал. 1, т. 2)',
    paid_marriage: 'При сключване на брак (чл. 157, ал. 1, т. 1)',
    paid_served_time: 'Прослужено време',
    paid_maternity: 'Майчинство',
    paid_paternity: 'Бащинство',
    paid_death: 'При загуба член на семейството (чл. 157, ал. 1, т. 3)',
    paid_training: 'Обучение',
    paid_ordinary_hint: 'Отсъствие по чл. 155, ал. 1 от КТ',
    paid_blood_donation_hint: 'Отсъствие по чл. 157, ал. 1, т. 2 от КТ',
    paid_marriage_hint: 'Отсъствие по чл. 157, ал. 1, т. 1 от КТ',
    paid_death_hint: 'Отсъствие по чл. 157, ал. 1, т. 3 от КТ',
    irregular_working_hours_hint: 'Отсъствие по чл. 156, ал. 1, т. 2 от КТ',
    specific_working_conditions_hint: 'Отсъствие по чл. 156, ал. 1, т. 1 от КТ',
    court_summons_hint: 'Отсъствие по чл. 157, ал. 1, т. 4 от КТ',
    paidShort: 'П',
    unpaidShort: 'Н',
    additionalShort: 'Д',
    sickShort: 'Б',
    annualTitle: 'Отсъствия за текущата година',
    generateRejectRequestDocument: 'Генерирай молба за прекратяване',
    rejectLeave: 'Отхвърли отпуска',
    leaveRejectedSuccessMsg: 'Отпускът е отхвърлен',
    upcomingTitle: 'Предстоящи отсъствия',
    colleagueCalendarTitle: 'Календар',
    previousLeavesInfo: 'Виж детайлна информация за отминали отсъствия',
    createSuccessMsg: 'Успешно заявихте своя отпуск / болничен',
    rejectRequestSuccessMsg: 'Успешно заявихте прекратяване на отпуск / болничен',
    initiated: 'Заявен',
    employeeRejectInitiated: 'Очакващ отхвърляне',
    inprogress: 'Oчаква потвърждение',
    pending: 'Очакващ одобрение',
    signing: 'В процес на подписване',
    confirmed: 'Одобрен',
    approve: 'Одобрен',
    approved: 'Очакващ подписване',
    signed: 'Подписан',
    interrupted: 'Прекъснат',
    confirmEmployeeRejection: 'Потвърди молбата за отказ',
    manuallyInsertLeave: 'Ръчно въвеждане на отсъствие',
    manuallyEditLeave: 'Редакция на отсъствие',
    takePaidLeaveDays: 'Вземи брой дни, от наличните на потребителя',
    manuallyInsertLeaveCreate: 'Създай отсъствие за служител',
    manuallyEditLeaveCreate: 'Редактирай отсъствие',
    manuallyInsertedLeave: 'Създадохте отсъствие за служител',
    manuallyEditedLeave: 'Редактирахте отсъствие за служител',
    manuallyInsertLeaveCreateConfirmation:
      'Със създаването на този отпуск, поемате отговорност, че за него има издадени и подписани необходимите книжа и служителят е уведомен.',
    manuallyEditLeaveCreateConfirmation:
      'С редактирането на този отпуск, поемате отговорност, че за него има издадени и подписани необходимите книжа и служителят е уведомен.',
    successfullyApproved: 'Успешно одобрен',
    rejected: 'Отхвърлен',
    cancelled: 'Анулиран',
    successMsg: 'Отпуската / Болничния беше изтрит',
    confirmHeading: 'Изтриване на документ',
    confirmMsg: 'Сигурни ли сте, че желаете да изтриете избрания документ?',
    confirmNotEnoughDaysHeading: 'Сигурни ли сте?',
    confirmNotEnoughDaysMsg:
      'Към момента този служител няма налични дни платен отпуск - отпускът е за {{paidDaysCount}} дни, служителят има общо {{remainingDays}} дни. Възможната причина е, че е заявил няколко отсъствия наведнъж и вече друг/и отпуски са използвали дните. Желаете ли все пак да подпишете този отпуск?',
    notEnoughDaysMsg:
      'Към момента този служител няма налични дни платен отпуск - отпускът е за повече дни отколкото служителят има общо. Възможната причина е, че е заявил няколко отсъствия наведнъж и вече друг/и отпуски са използвали дните. Имате възможност да извършите действието само единично.',
    holiday: 'Празник',
    requestedHalfDay: 'Заявен половин ден',
    requestHalfDay: 'Заяви половин ден',
    portionOfDay: 'Част от деня',
    firstPortionOfDay: 'Първа половина на деня',
    secondPortionOfDay: 'Втората половина на деня',
    comment: 'Коментар',
    noComment: 'Няма коментар',
    commentInfo: 'Коментарът ще бъде видим за Вашият работодател',
    from: 'от',
    fromYear: 'От',
    used: 'са използвани',
    on: 'на',
    yearShort: 'г.',
    yearShortOnlyBG: 'г.',
    day: 'ден',
    days: 'дни',
    hoursSmall: 'ч.',
    eSign: 'Eлектронно подписване',
    eSignSubtitle: 'Зареждане на сертификатите за подпис',
    confirmLeaveAware: 'Сигурни ли сте, че сте запознати с тези отпуски?',
    confirmApproveLeaveMsg: 'Наистина ли искате да одобрите тези отпуски?',
    confirmSignLeaveMsg: 'Наистина ли искате да подпишете тези отпуски?',
    requestLeave: 'Заяви отсъствие',
    integerRequired: 'Полето трябва да бъде цяло число',
    monthTableWarning: 'Виждате данните за дни отсъствия само за групи/служители до които имате достъп.',
    groupTableWarning: 'Общият брой дни, може да бъде различен, поради служители, които са в повече от една група.',
    colleagueInfoMessage:
      'Тук виждате отпуски на колегите, с които споделяте групи/отдели. За да управлявате отпуски на ваши подчинени,',
    switchWorkMode: 'преминете в режим {{workmode}}.',
    expand: 'Разшири календара и покажи всички отсъствия',
    collapse: 'Свий календара и покажи ограничен брой отсъствия',
    allLeaves: 'Всички отсъствия',
    switchTo: 'Превключи към',
    showGridView: 'Изглед по дни',
    showCalendarView: 'Календарен изглед',
    workTrips: 'Командировки',
    showWorkTrips: 'Покажи всички командировки',
    hideWorkTrips: 'Скрий всички командировки',
    multipleOfHalfRequired:
      'Полето трябва да бъде цяло число или кратно на 0.5, стойността ще бъде закръглена до най-близката кратна на 0.5',
    interruptOverlapHeading: 'Припокриване на отпуск',
    interruptConfirmMsg: 'Желаете ли да прекратите посоченото отсъствие и да продължите със заявяване на болничен?',
    interruptLoadingMsg: 'Прекъсване на отсъствие...',
    substituteEmployeeName: 'Заместващ',
    rejectReason: 'Причина за отхвърляне',
    tooltip: {
      id: 'Отсъствие №{{id}}',
    },
    validation: {
      error: 'Грешка при валидация',
      lockedLeaves: 'Има заключени отпуски в процес на одобрение.',
      exceedsPaidOrdinary:
        'За някои отсъствия няма да бъде предприето действие понеже {{user}} надвишава наличните основни платени дни ({{available}} налични, {{requested}} заявени).',
      exceedsAdditional:
        'За някои отсъствия няма да бъде предприето действие понеже {{user}} надвишава наличните допълнителни дни ({{available}} налични, {{requested}} заявени).',
      exceedsServedTime:
        'За някои отсъствия няма да бъде предприето действие понеже {{user}} надвишава наличните дни за прослужено време ({{available}} налични, {{requested}} заявени).',
      errorFetchingData: 'Грешка при проверка на дните. Моля опитайте отново.',
      massAction: {
        approve: {
          header:
            'При подписване, някой отсъствия на следните потребители няма да бъдат обработени масово, поради недостатъчна наличност на дни.',
        },
        sign: {
          header:
            'Някои отсъствия на следните потребители няма да бъдат подписани масово, поради недостатъчна наличност на дни.',
        },
        paidType: 'Платен',
        servedTimeType: 'Прослужено време',
        additionalType: 'Допълнителен',
        userFormat: '{{user}} - налични {{available}}, заявени общо {{requested}}',
      },
    },
    actions: {
      title: 'Действия',
      approved: 'Одобрен',
      signed: 'Подписан',
      rejected: 'Отхвърлен',
      created: 'Създаден',
    },
    table: {
      multiActions: 'Множествени действия',
      approval: 'Одобрение',
      signing: 'Подписване',
      approve: 'Одобри',
      sign: 'Подпиши',
    },
    legend: {
      paid: 'Платен',
      paidOrdinary: 'Други платени',
      unpaid: 'Неплатен',
      sick: 'Болничен',
      additional: 'Допълнителен',
      work_from_home: 'Работа от разстояние',
      work_from_office: 'Работа от офис',
      tooltip: 'В по-блед цвят са непотвърдени отсъствия',
      confirmed: 'Одобрен',
      notConfirmed: 'Неодобрен',
      waitingForConfirmation: 'Очаква потвърждение',
      homeConfirmed: 'Работа от вкъщи',
      waitingHomeConfirmation: 'Работа от вкъщи (непотвърден)',
      officeConfirmed: 'Работа от офис',
      waitingOfficeConfirmation: 'Работа от офис (непотвърден)',
    },
    months: {
      1: 'Януари',
      2: 'Февруари',
      3: 'Март',
      4: 'Април',
      5: 'Май',
      6: 'Юни',
      7: 'Юли',
      8: 'Август',
      9: 'Септември',
      10: 'Октомври',
      11: 'Ноември',
      12: 'Декември',
    },
    employee: {
      confirmRejectConfirmedLeaveMsg: 'Наистина ли искате да отхвърлите одобрения отпуск/болничен?',
    },
    employer: {
      calendarView: 'Календар',
      statisticsView: 'Статистика',
      tableView: 'Табличен изглед',
      leavesTableView: 'Отсъствия очакващи одобрение',
      leavesTableCompletedView: 'Одобрени и отхвърлени отсъствия',
      name: 'Име',
      confirmRejectLeaveMsg: 'Наистина ли искате да отхвърлите искането за отпуск/болничен?',
      confirmLeaveRejectRequestMsg: 'Наистина ли искате да потвърдите искането за прекратяване на отпуск/болничен?',
      rejectedLeaveSuccessMsg: 'Искането за отпуск/болничен беше отхвърлено',
      unprocessedLeavesWarning:
        'Има отсъствия за предишен период (между {{minDate}} и {{maxDate}}) за които действията не са завършени. Моля филтрирайте за задна дата и проверете',
      calendar: {
        allDay: 'Цял ден',
        previous: 'Назад',
        next: 'Напред',
        today: 'Днес',
        month: 'Месец',
        week: 'Седмица',
        day: 'Ден',
        agenda: 'Легенда',
        date: 'Дата',
        time: 'Време',
        event: 'Събитие',
        showMore: '+ още {{total}}',
      },
    },
    grid: {
      employeeName: 'Служител',
      noEmployeesWithLeaves: 'Няма служители с отсъствия за избрания месец',
      onlyEmployeesWithAbsence: 'Визуализират се само служители с някакъв тип отсъствие за месеца',
      actionsHeading: 'Действия',
    },
    interruptionInfo: 'Информация за прекъсване',
    interruptedBy: 'Прекъснат от болничен',
    interrupts: 'Този болничен прекъсва следните отсъствия',
    duration: 'Продължителност',
    id: 'Номер',
  },
  healthAndSafetyTraining: {
    title: 'Здравословни и безопасни условия на труд',
    titleShort: 'ЗБУТ',
    create: 'Създаване на инструктаж',
    user: 'Служител',
    users: 'Служители',
    type: 'Тип',
    facilitator: 'Провеждащ',
    status: 'Статус',
    actions: 'Действия',
    documentNumber: 'Номер',
    group: 'Група',
    groups: 'Групи',
    date: 'Дата',
    isMassTraining: 'Масово създаване',
    selectedUsers: 'Избрани',
    excludeUser: 'Премахни',
    includeUser: 'Избери',
    confirmCreate: 'Сигурни ли сте, че искате да създадете този инструктаж?',
    confirmMassCreate: 'Сигурни ли сте, че искате да създадете този инструктаж за множество служители?',
    success: 'Успешно създадохте инструктаж',
    massSuccess: 'Успешно създадохте масово инструктаж',
    downloadReport: 'Свали справка',
    confirmSignMsg: 'Сигурни ли сте, че тези инструктажи са проведени, и искате да ги подпишете масово?',
    confirmDeleteHeading: 'Изтриване на инструктажи',
    confirmDeleteMsg: 'Сигурни ли сте, че искате да изтриете тези инструктажи?',
    confirmDeleteHeadingSingle: 'Изтриване на инструктаж',
    confirmDeleteMsgSingle: 'Наистина ли искате да изтриете този инструктаж?',
    deletedSuccessMsg: 'Инструктажът е изтрит!',
    deletedSuccessMsg_plural: 'Инструктажите бяха изтрити!',
    selectOnlyActive: 'Избери само активни',
    types: {
      initial: 'Начален',
      periodic: 'Периодичен',
      emergency: 'Извънреден',
      at_workplace: 'На работно място',
    },
    statuses: {
      created: 'Очаква подпис от провеждащ',
      signed_by_employer: 'Очаква подпис от служител',
      completed: 'Извършен',
      rejected: 'Отхвърлен',
    },
    tabs: {
      list: 'Очакващи действия',
      completedList: 'Извършени и отхвърлени',
    },
  },
  workTrips: {
    title: 'Командировки',
    create: 'Нова командировка',
    createSuccess: 'Успешно създадохте командировка',
    confirmCreate: 'Сигурни ли сте, че искате да създадете тази командировка?',
    tripIn: 'Командировка в',
    domestic: 'България',
    foreign: 'Чужбина',
    country: 'Държава',
    user: 'Служител',
    group: 'Група',
    destination: 'Дестинация',
    city: 'Град',
    route: 'Маршрут',
    period: 'От - До',
    fromDate: 'Начална дата',
    toDate: 'Крайна дата',
    daysCount: 'Брой дни',
    overnightStays: 'Брой нощувки',
    higherDailyAllowance: 'Стандартен размер на дневни',
    dailyAllowanceIncreasePercent: 'Процент увеличение (0-100%)',
    dailyAllowance: 'Дневни',
    dailyAllowanceRange: 'Допустим диапазон: от {{min}} до {{max}} EUR',
    task: 'Задача',
    transportType: 'Вид транспорт',
    transportDetails: 'Допълнителна информация транспорт',
    dailyAllowancePaymentType: 'Начин на плащане - дневни',
    accommodationPaymentType: 'Начин на плащане - квартирни',
    accommodationOvernightStaysType: 'Квартирни (Нощувки)',
    accommodationAmount: 'Стойност нощувка (на вечер)',
    accommodationAmountRange: 'Допустим диапазон: до {{max}} EUR',
    travelPaymentType: 'Начин на плащане - пътни',
    travelAmount: 'Пътни (стойност)',
    totalCost: 'Общ разход',
    status: 'Статус',
    actions: 'Действия',
    reportGenerate: 'Създаване на отчет',
    reportCreateSuccess: 'Успешно създадохте отчет',
    reportExplanation: 'Отчет за извършена работа по командировка',
    reportDifficulties: 'При изпълнение на задачата, срещнах следните трудности',
    reportVehicleRegistrationNumber: 'Рег. номер на автомобил',
    reportTravelInvoiceAmount: 'Обща сума по приложен документ/и за пътни',
    reportAccommodationInvoiceAmount: 'Обща сума по приложен документ/и за квартирни',
    previewOrder: 'Преглед заповед',
    previewReport: 'Преглед отчет',
    previewReportDocuments: 'Преглед отчетни документи',
    confirmSignMsg: 'Сигурни ли сте, че искате да подпишете избраните командировки?',
    statuses: {
      created: 'Очаква подпис от работодател',
      signed_by_employer: 'Очаква подпис от служител',
      awaiting_facilitation: 'Очаква провеждане',
      signed_by_employee: 'Завършена, очаква отчет',
      report_created: 'Завършена, очаква подпис от служител',
      report_signed_by_employee: 'Завършена, очаква подпис от работодател',
      report_signed_by_employer: 'Завършена и отчетена',
      status_employer_signed: 'Очаква подпис от служител',
      status_employee_signed: 'Завършена, очаква отчет',
    },
    tabs: {
      list: 'Предстоящи и очакващи отчет',
      completedList: 'Приключили и отчетени командировки',
      calendar: 'Календар',
      report: 'Справка',
    },
    legend: {
      awaitingSignature: 'Очаква подпис',
      awaitingReport: 'Очаква отчет',
      completed: 'Приключена',
    },
  },
  work_trips: {
    status_employer_signed: 'Очаква подпис от служител',
    status_employee_signed: 'Завършена, очаква отчет',
    travel_payment_cash: 'в брой',
    travel_payment_bank: 'по банка',
    travel_payment_expensed_to_hosting_party: 'за сметка на посрещащата страна',
  },
  hourlyAbsences: {
    title: 'Почасови отсъствия',
    dateFrom: 'Начална дата и час',
    dateTo: 'Крайна дата и час',
    status: 'Статус',
    employee: 'Служител',
    lunchbreak: 'Обедна почивка',
    noLunchBreak: 'Няма',
    lunchbreakHalf: '30 минути',
    lunchbreakOne: '1 час',
    group: 'Група',
    actions: 'Действия',
    name: 'Име',
    date: 'Дата, час от - до',
    hours: 'Часове',
    leaveApplied: 'Заявено и потвърдено отсъствие',
    yes: 'Да',
    no: 'Не',
    partialCovered: 'Частично — {{covered}} / {{total}} ч.',
    create: 'Създаване на почасово отсъствие',
    createEmployee: 'Заявяване на почасово отсъствие',
    confirmationMessage: 'Сигурни ли сте, че искате да създадете това почасово отсъствие?',
    confirmationMessageEmployee: 'Сигурни ли сте, че искате да заявите това почасово отсъствие?',
    confirm: 'Да, създай!',
    confirmEmployee: 'Да, заяви!',
    createSuccess: 'Успешно създадохте почасово отсъствие',
    createSuccessEmployee: 'Успешно заявихте почасово отсъствие',
    requestMyHourlyAbsence: 'Заяви почасово отсъствие',
    downloadReport: 'Свали справка',
    comment: 'Коментар',
    commentInfoManual: 'Коментарът ще бъде видим за служителя.',
    commentInfoManualEmployee: 'Коментарът ще бъде видим за Вашият работодател',
    createdAt: 'Създадено на',
    updatedAt: 'Обновено на',
    inputs: {
      date: 'Дата',
      timeFrom: 'От час',
      timeTo: 'До час',
    },
    confirmAbsence: {
      delete: 'Сигурни ли сте, че искате да изтриете това почасово отсъствие?',
      approve: 'Сигурни ли сте, че искате да одобрите това почасово отсъствие?',
      reject: 'Сигурни ли сте, че искате да отхвърлите това почасово отсъствие?',
    },
    statuses: {
      confirmed: 'Одобрен',
      pending: 'Очакващ одобрение',
      rejected: 'Отхвърлен',
    },
    remainingHours: 'Оставащи часове за почасови отсъствия',
    hoursLabel: 'ч.',
    uncoveredHours: 'Общо непокрити часове',
    hoursAboutToBeCovered: 'Ще бъдат покрити след одобрение на отпуски',
  },
  documentScenarioInfo: {
    'I-1': 'Подпис от Вас работодателя, а след това от служителя',
    'I-2': 'Дигитализиране на хартиен документ',
    'I-3': 'Одобрение и подпис само от служителя',
    'I-4': 'Подпис от служителя, а след това и от Вас, работодателя',
    'I-5': 'Одобрение и подпис само от Вас, работодателя',
    'II-1': 'Одобрение и подпис от работодател, след което одобрение и подпис от Вас, служителя',
    'II-2': 'Одобрение и подпис от Вас, служителя',
  },
  trainingMaterials: {
    pdfs: {
      manualBG: 'Ръководство на български',
      manualEN: 'Ръководство на английски',
      manualLeaves: 'Ръководство за отпуски',
      moduleLeaves: 'Визуално представяне на Отпуски',
      moduleKep: 'Ръководство за настройка на КЕП',
    },
    videos: {
      employee: {
        accountActivation: {
          title: 'Активиране на акаунт',
          description: 'Първата част от процеса по активиране на вашия акаунт - избор на парола.',
        },
        enableTwoFA: {
          title: 'Активиране на двуфакторна аутентикация',
          description: 'Втората част от процеса по активиране на вашия акаунт - настройка на двуфакторна автентикация.',
        },
        requestLeave: {
          title: 'Заявяване на отпуск',
          description:
            'Описание на процеса по заявява и подписване на отпуск, преглед на предстоящи и минали отпуски (и болнични)',
        },
        approvalAndSigningOfDocument: {
          title: 'Одобряване и подписване на получен документ',
          description:
            'Описание на процеса по преглед на получен документ, неговото одобрение и последващо подписване с вградения в eHR електронен подпис',
        },
        createApprovalAndSigningOfDocument: {
          title: 'Създаване, одобрение и подписване на външен документ',
          description: 'Описание на качване на външен PDF файл, като документ в системата',
        },
        createApprovalAndSigningOfDocumentTemplate: {
          title: 'Създаване, одобрение и подписване на документ от шаблон',
          description: 'Представяне на функционалността за създаване на документ от вградените в системата шаблони.',
        },
      },
      employer: {
        addLeaveManually: {
          title: 'Ръчно добавяне на отпуск',
          description:
            'Представяне на функционалността за ръчно въвеждане на отсъствие за служител. Удобна при нужда от добавка на отсъствие, което е било одобрено (или ще бъде) на хартия.',
        },
        editLeave: {
          title: 'Редакция на отпуск',
          description: 'Възможност за редакция на въведени ръчно отсъствия чрез горната функциоланост.',
        },
        digitalizePaperDocument: {
          title: 'Дигитализиране на хартиен документ',
          description: 'Представяне на възможността за създаване на електронен оригинал на хартиен документ.',
        },
        bulkDocumentCreation: {
          title: 'Масово създаване на документи',
          description:
            'Представяне на функционалността за масово създаване на документи, за служители от множество групи.',
        },
        massApprovalAndSigning: {
          title: 'Масово одобрение и подписване на отпуски',
          description: 'Преглед на функционалността по масово одобрение и подписване на Отпуски.',
        },
      },
    },
  },
  archives: {
    title: 'Архиви',
    status: 'Статус',
    type: 'Тип',
    fileName: 'Име на файл',
    createdAt: 'Създаден',
    downloading: 'Изтегля се...',
    download: 'Изтегли',
    noArchives: 'Няма налични архиви',
    documents: 'документа',
    from: 'от',
    viewArchives: 'Виж архиви',
    archiveReady: 'Вашият архив е готов и е достъпен за изтегляне!',
    downloadError: 'Грешка при изтегляне на архива. Моля опитайте отново.',
    invalidArchiveId: 'Невалиден идентификатор на архив',
    preparingDownload: 'Подготвя се изтеглянето...',
    statusPending: 'В изчакване',
    statusGenerating: 'Генерира се (започнато на {{time}})',
    statusReadyForDownload: 'Готов (изтича на {{time}})',
    statusExpired: 'Изтекъл',
    types: {
      documentsTab: 'Документи',
      leavesTab: 'Отпуски',
      reportsDocumentsTab: 'Справка документи',
      reportsDocumentActionsTab: 'Справка действия по документи',
      healthAndSafetyTab: 'ЗБУТ',
      workTripsTab: 'Командировки',
    },
  },
  errors: {
    noConnection:
      'Изглежда имате нестабилна връзка или никаква връзка с интернет. Моля изчакайте, рестартирайте или се обърнете към вашият доставчик/работодател.',
    serverUnavailable:
      'Изглежда в момента няма връзка с част от услугите на eHR. Екипът ни вече е уведомен - моля опитайте по-късно.',
  },
};

export default bg;
